<!-- eslint-disable @angular-eslint/template/no-negated-async -->
@if (!changingTenantSite && !(tenantService.changingTenant$ | async)) {
  @if ((tenantService.tenants$ | async)!.length > 0) {
    <button
      class="menu-dropdown"
      (click)="showMenu()"
      #menuTrigger="matMenuTrigger"
      [matMenuTriggerFor]="menu"
      (menuOpened)="scrollToCurrentSite()">
      <button
        mat-mini-fab
        [style.backgroundImage]="
          'url(assets/icons/BLU_Organization_Icon.svg)'
        "></button>
      <div class="selector-wrapper">
        @if (selectedTenant) {
          <span
            class="tenant-label uppercase"
            [truncateHover]="selectedTenant.name">
            {{ selectedTenant?.name }}
          </span>
        } @else {
          <span class="label uppercase">{{
            tenantService.initialTenantName
          }}</span>
        }
        @if (hierarchyService.hasAssignedRegion$ | async) {
          <span
            class="site-label uppercase"
            [class.site-label-inactive]="isSiteDeactivated(selectedTenantSite)"
            [truncateHover]="
              (selectedTenantRegion?.name === 'Unassigned'
                ? 'Default Region'
                : selectedTenantRegion?.name) +
              ' - ' +
              selectedTenantSite?.name
            "
            >{{
              selectedTenantRegion?.name === 'Unassigned'
                ? 'Default Region'
                : selectedTenantRegion?.name
            }}
            - {{ selectedTenantSite?.name }}
          </span>
        }
        @if (!(hierarchyService.hasAssignedRegion$ | async)) {
          <span
            class="site-label uppercase"
            [class.site-label-inactive]="isSiteDeactivated(selectedTenantSite)"
            [truncateHover]="selectedTenantSite.name">
            {{ selectedTenantSite?.name }}
          </span>
        }
      </div>
    </button>
  } @else {
    <span class="label uppercase" [truncateHover]="selectedTenant.name">
      {{ selectedTenant.name }}
    </span>
  }
  <mat-menu #menu="matMenu" class="tenant-menu-material tenantMenu">
    <div class="callout">
      <div class="triangle"></div>
      <div class="inner-triangle"></div>
    </div>
    <div
      class="menu-wrapper tenant-menu-primeng"
      (click)="$event.stopPropagation()">
      <div class="search-wrapper">
        <div class="search">
          <mat-form-field appearance="outline" class="hide-subscript">
            <input
              type="text"
              matInput
              [formControl]="searchControl"
              placeholder="Search"
              i18n-placeholder />
            @if (searchControl.value?.length === 0) {
              <button matSuffix mat-icon-button>
                <mat-icon>search</mat-icon>
              </button>
            }
            @if (searchControl.value?.length > 0) {
              <button
                matSuffix
                mat-icon-button
                (click)="searchControl.setValue('')">
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="dropdown-item-wrapper">
        @for (tenant of tenants; track tenant.id) {
          @if (tenant.meta['isVisible']) {
            <div class="entry">
              <div
                [ngClass]="{
                  tenant: true,
                  active: tenant.id === selectedTenant.id
                }"
                (click)="toggleItem(tenant)">
                <img
                  [src]="'Company Management' | icon: 'Icon'"
                  class="sidebar-icon" />
                <span [truncateHover]="tenant.name" class="tenant-title">
                  {{ tenant.name }}
                </span>
              </div>
              @if (tenant.regions.length > 1) {
                <ul class="region-list">
                  @for (region of tenant.regions; track region.id) {
                    @if (region.meta['isVisible']) {
                      <li class="region">
                        <div
                          (click)="toggleItem(region)"
                          [ngClass]="{
                            'region-title': true,
                            active: region.id === selectedTenantRegion.id
                          }">
                          <img [src]="'Region' | icon: 'Icon'" />
                          <span [truncateHover]="region.name">{{
                            region.name === 'Unassigned'
                              ? 'Default Region'
                              : region.name
                          }}</span>
                        </div>
                        <ul class="site-list">
                          @for (site of region.sites; track site.id) {
                            @if (
                              site.meta['isVisible'] &&
                              isSiteAvailableToSelect(tenant.id, site)
                            ) {
                              <li
                                class="site"
                                (click)="
                                  $event.stopPropagation();
                                  selectSite(tenant, site)
                                ">
                                @if (site.meta['isVisible']) {
                                  <div
                                    [ngClass]="{
                                      'site-title': true,
                                      disabled:
                                        site.id === selectedTenantSite.id,
                                      active: site.id === selectedTenantSite.id,
                                      selectedSite:
                                        site.id === selectedTenantSite.id
                                    }"
                                    [class.inactive-mask]="
                                      isSiteDeactivated(site)
                                    "
                                    [truncateHover]="site.name">
                                    <img [src]="'Location' | icon: 'Icon'" />
                                    <span [truncateHover]="site.name">{{
                                      site.name
                                    }}</span>
                                  </div>
                                }
                              </li>
                            }
                          }
                        </ul>
                      </li>
                    }
                  }
                </ul>
              } @else {
                @for (region of tenant.regions; track region.id) {
                  <ul class="site-list">
                    @for (site of region.sites; track site.id) {
                      @if (
                        site.meta['isVisible'] &&
                        isSiteAvailableToSelect(tenant.id, site)
                      ) {
                        <li
                          class="site"
                          (click)="
                            $event.stopPropagation(); selectSite(tenant, site)
                          ">
                          <div
                            [ngClass]="{
                              'site-title': true,
                              disabled: site.id === selectedTenantSite.id,
                              active: site.id === selectedTenantSite.id,
                              selectedSite: site.id === selectedTenantSite.id
                            }"
                            [class.inactive-mask]="isSiteDeactivated(site)"
                            [truncateHover]="site.name">
                            <img [src]="'Location' | icon: 'Icon'" />
                            <span [truncateHover]="site.name">{{
                              site.name
                            }}</span>
                          </div>
                        </li>
                      }
                    }
                  </ul>
                }
              }
            </div>
          }
        }
      </div>
    </div>
  </mat-menu>
} @else {
  <img
    [style.opacity]="changingTenantSite"
    class="loading-spinner"
    src="assets/img/spin-loader.gif" />
}

<ng-template #noSiteName>
  <span class="site-label uppercase"
    ><ng-container i18n>No Site available</ng-container></span
  >
</ng-template>
